if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
  
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
  
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
        this.handleErrorMessage();
  
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
       // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // window.location = window.routes.cart_url;
              const dcDrawerAutoUpdate = new Event("DC_AUTO_UPDATE_DRAWER", {
bubbles: true,
});
document.dispatchEvent(dcDrawerAutoUpdate);
               $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        console.log(cart.item_count);
        $('#cart-app .cart-container .badge').text(cart.item_count);
        const dcDrawerAutoUpdate = new Event("DC_AUTO_UPDATE_DRAWER", {
bubbles: true,
});
document.dispatchEvent(dcDrawerAutoUpdate);
      },
      error: function(error) {
        alert(error);
      }
    });
              return;
            }
  
            this.error = false;
       
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      
          });
      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    });
  }
  
$(document).ready(function(){
  $('.show-more-description').click(function(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    $('html, body').animate({
        scrollTop: $('.description').addClass('in').offset().top - 170
    }, 1000);
});



$(function() {
    const $description = $('.description');
    if ($description.length > 0) {
        const $descriptionTop = $('.description').offset().top;
        if ($description.height() > 300) {
            $description.addClass('readmore');
        }
        $description.on('click', function() {
            $description.toggleClass('in');
            if ((!$description.hasClass('in')) && ($(window).scrollTop() >= $descriptionTop)) {
                $('html, body').animate({
                    scrollTop: $description.offset().top - 170
                }, 400);
            }
        });
    }
});



$('.button.button-main.addtocart').click(function(evt){
  evt.preventDefault();
  evt.stopImmediatePropagation();
  $this = $(this);
 $this.addClass('disabled');
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $('.form[data-type="add-to-cart-form"]').serialize(),
    success: function(){
      $.ajax({
        type: 'GET', 
        url: '/cart.js',dataType:'json',
        success: function(cart){ console.log(cart.item_count) 
        
        $('#cart-app .cart-container .badge').text(cart.item_count);
                                const dcDrawerAutoUpdate = new Event("DC_AUTO_UPDATE_DRAWER", {
bubbles: true,
});
document.dispatchEvent(dcDrawerAutoUpdate);
        $this.removeClass('disabled');
        }
      
      });

    },
    error: function(error){
alert(error);
    }
 });

});



});

$(document).ready(function(){
    $('[data-fancybox="gallery"]').fancybox({loop:true,arrows:false,infobar:false,buttons:['fullScreen','close',],animationDuration:0,thumbs:{autoStart:true,axis:'x'},baseClass:'fancybox-images',slideClass:'fancybox-image-container',});


    const randomNum = Math.floor(Math.random() * (67 - 1 + 1)) + 1;
    $('.users').text(randomNum);
    $('.viral').show();
})